<div class="input-wrapper">
    <mat-form-field>
        <input
            #input
            matInput
            class="text-input"
            [class.text-input--border]="!whiteTheme"
            [placeholder]="label"
            [value]="value"
        />
    </mat-form-field>
</div>
